import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

/**
 * Tab "Web Legacy": configuración exclusiva de la app web vieja
 * (seguridad-boton-web): los colores y las imágenes "Push" (botón apretado). La app nativa no
 * usa nada de acá (las imágenes compartidas viven en la tab App Nativa).
 * Recibe el formulario raíz por referencia: edita los mismos controles.
 */
@Component({
  selector: 'app-tab-web-legacy',
  templateUrl: './tab-web-legacy.component.html',
  standalone: false,
})
export class TabWebLegacyComponent {
  @Input() public formulario?: UntypedFormGroup;

  get imagenes(): UntypedFormGroup {
    return this.formulario?.get('imagenes') as UntypedFormGroup;
  }

  /** La subida de imágenes necesita el nombre del cliente (ruta en el bucket). */
  public nombresValido(): boolean {
    return !!this.formulario?.get('nombre')?.value;
  }

  get configuracion(): UntypedFormGroup {
    return this.formulario?.get('configuracion') as UntypedFormGroup;
  }

  public onColorChange(event: string, control: string): void {
    this.configuracion?.get(control)?.patchValue(event);
  }
}
